import { get } from "lodash";
import isContentKey from "./helpers/isContentKey";
export var getErrorMessage = function (err) {
    var msg = "There was some sort of error";
    var dataMsg = get(err, "response.data.message", null);
    var graphErrorMsg = get(err, "networkError.message", null);
    var errorMsg = get(err, "message", null);
    if (isContentKey(graphErrorMsg)) {
        msg = graphErrorMsg;
    }
    else if (isContentKey(errorMsg)) {
        msg = errorMsg;
    }
    else if (dataMsg) {
        msg = dataMsg;
    }
    return msg;
};
export var getErrorValues = function (err) {
    var data = (err === null || err === void 0 ? void 0 : err.data) || {};
    var graphErrorData = get(err, "networkError.errorData", null);
    var errorData = get(err, "errorData", null);
    if (graphErrorData) {
        data = graphErrorData;
    }
    else if (errorData) {
        data = errorData;
    }
    return data;
};
